import styled from "styled-components";

export const Container = styled.div``;

export const LimitNote = styled.p`
  margin-top: 12px;
  color: var(--color-neutral-light);
  font-size: 14px;
  line-height: 20px;
`;
